import { render, staticRenderFns } from "./ContextIndexSection.vue?vue&type=template&id=36ce1e11&scoped=true&"
import script from "./ContextIndexSection.vue?vue&type=script&lang=js&"
export * from "./ContextIndexSection.vue?vue&type=script&lang=js&"
import style0 from "./ContextIndexSection.vue?vue&type=style&index=0&id=36ce1e11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce1e11",
  null
  
)

export default component.exports